import { createSelector } from 'reselect';
import EDUCATION_TYPE_OTHER from './SchoolTypeConstants';
import { whatIfInnerSelector, whatIfOptionsOrDefaultSelector } from '../../WhatIfsSelector';

export const educationTypeSelector = (state, props) =>
  whatIfInnerSelector(state, props).EducationType;

export const yearlyCostSelector = (state, props) => whatIfInnerSelector(state, props).YearlyCost;

export const yearsOptionsSelector = createSelector(
  whatIfOptionsOrDefaultSelector,
  whatIfOptionsOrDefault =>
    (whatIfOptionsOrDefault.EducationTypeOptions || []).map((education) => {
      const words = education.description.split(' ');
      let title;
      let sliceIndex;
      const { value: type } = education;

      if (type === EDUCATION_TYPE_OTHER) {
        [title] = words;
        sliceIndex = 1;
      } else {
        title = `${words[0]} ${words[1]}`;
        sliceIndex = 2;
      }
      const description = words
        .slice(sliceIndex)
        .join(' ')
        .replace(/[()]/g, '');
      return {
        type,
        title,
        description,
      };
    }),
);

export const specificCollegeInformationSelector = createSelector(
  whatIfOptionsOrDefaultSelector,
  whatIfOptionsOrDefault => whatIfOptionsOrDefault.SpecificCollegeInformation,
);
